import React from "react"
import AutounclePicturemark from "icons/branding/autouncle-picturemark.svg?react"
import AutouncleLogo from "icons/branding/autouncle-logo.svg?react"
import styled from "styled-components"
import { Link, type LinkProps } from "react-router-dom"

const HomeLinkWrapper = ({
  link,
  ...props
}: Omit<LinkProps, "to"> & { link?: string }) =>
  link ? <a href={link}>{props.children}</a> : <Link to={"/"} {...props} />

const LogoWrapper = styled.div`
  padding: 20px 16px;

  > svg {
    display: inline-block;
    vertical-align: middle;
  }
`

const HomeLink = ({
  collapsed,
  link,
}: {
  collapsed: boolean
  link?: string
}) => {
  const Logo = collapsed ? AutounclePicturemark : AutouncleLogo

  return (
    <HomeLinkWrapper link={link}>
      <LogoWrapper>
        <Logo fill="white" height="18" />
      </LogoWrapper>
    </HomeLinkWrapper>
  )
}

export default HomeLink